import { createSlice } from '@reduxjs/toolkit';
import {
    Bundle,
    Course,
    Test
} from 'global/types';

interface CartState {
    isUpdatingCart: boolean;
    updatedCart: boolean;
    bundles: Bundle[];
    courses: Course[];
    tests: Test[];
    promoCode: string;
};

const initialState: CartState = {
    isUpdatingCart: true,
    updatedCart: false,
    bundles: [],
    courses: [],
    tests: [],
    promoCode: '',
};

export const cartSlice = createSlice({
    name: 'cart', 
    initialState, 
    reducers: {
        initializeCart: (state, action) => {
            const {
                bundles,
                courses,
                tests,
                promoCode
            } = action.payload;

            state.bundles = bundles ? bundles : state.bundles;
            state.courses = courses ? courses : state.courses;
            state.tests = tests ? tests : state.tests;
            state.promoCode = promoCode ? promoCode : state.promoCode;
            state.isUpdatingCart = false;
        },
        updateCart: (state, action) => {
            const {
                bundles,
                courses,
                tests,
                promoCode
            } = action.payload;

            state.bundles = bundles ? bundles : state.bundles;
            state.courses = courses ? courses : state.courses;
            state.tests = tests ? tests : state.tests;
            state.promoCode = promoCode ? promoCode : state.promoCode;
            state.isUpdatingCart = false;
            state.updatedCart = true;
        },
        resetCart: state => {
            state.bundles = initialState.bundles;
            state.courses = initialState.courses;
            state.tests = initialState.tests;
            state.promoCode = initialState.promoCode;
            state.isUpdatingCart = initialState.isUpdatingCart;
            state.updatedCart = initialState.updatedCart;
        },
        closeMessage: state => {
            state.updatedCart = false;
        },
    }
});

export const {
    initializeCart,
    updateCart,
    resetCart,
    closeMessage
} = cartSlice.actions;

export default cartSlice.reducer;